<svelte:options tag="website-nglesson" />

<script lang="ts">
  import interact from "interactjs";
  import pdfobject from "pdfobject";
  import "prismjs";
  import "prismjs/plugins/line-numbers/prism-line-numbers.js";
  import "prismjs/components/prism-c.js";
  import "prismjs/components/prism-lua.js";
  import "prismjs/components/prism-cpp.js";
  import "prismjs/components/prism-r.js";
  import "prismjs/components/prism-swift.js";
  import "prismjs/components/prism-ruby.js";
  import "prismjs/components/prism-dart.js";
  import "prismjs/components/prism-typescript.js";
  import "prismjs/components/prism-csharp.js";
  import "prismjs/components/prism-rust.js";
  import "prismjs/components/prism-sql.js";
  import "prismjs/components/prism-kotlin.js";
  import "prismjs/components/prism-java.js";
  import "prismjs/components/prism-go.js";
  import "prismjs/components/prism-python.js";
  import marked from "marked";
  import { ContentTypes, Lesson } from "./model";
  import Fa from "svelte-fa/dist/svelte-fa";
  import {
    faArrowRight,
    faArrowLeft,
    faWindowMinimize,
    faTimes,
  } from "@fortawesome/free-solid-svg-icons";
  import { onMount, tick } from "svelte";
  export let top = 300;
  export let left = 300;
  let restart = {};
  onMount(() => {
    (window as any).Prism = (window as any).Prism || {};
    (window as any).Prism.manual = true;
  });
  let min = false;
  let stepIndex = 0;
  let lesson: Lesson<any>;
  let preEl;
  let lessonContainerEl;
  const interactEl = interact("#nglesson-container")
    .draggable({
      allowFrom: "#header",
      ignoreFrom: "iframe",
      listeners: {
        move: (event) => {
          var target = event.target;
          // keep the dragged position in the data-x/data-y attributes
          var x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
          var y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;

          // translate the element
          target.style.webkitTransform = target.style.transform =
            "translate(" + x + "px, " + y + "px)";

          // update the posiion attributes
          target.setAttribute("data-x", x);
          target.setAttribute("data-y", y);
        },
      },
      inertia: true,
      modifiers: [
        interact.modifiers.restrictRect({
          restriction: {
            top: 0,
            left: 0,
            bottom: Infinity,
            right: Infinity,
          },
          enabled: true,
          endOnly: true,
        }),
      ],
    })
    .resizable({
      ignoreFrom: "iframe",
      modifiers: [
        // minimum size
        interact.modifiers.restrictSize({
          min: { width: 480, height: 270 },
        }),
      ],
      edges: { top: true, left: true, bottom: true, right: true },
      listeners: {
        move: function (event) {
          let { x, y } = event.target.dataset;

          x = (parseFloat(x) || 0) + event.deltaRect.left;
          y = (parseFloat(y) || 0) + event.deltaRect.top;

          Object.assign(event.target.style, {
            width: `${event.rect.width}px`,
            height: `${event.rect.height}px`,
            transform: `translate(${x}px, ${y}px)`,
          });

          Object.assign(event.target.dataset, { x, y });
        },
      },
    });

  $: stepIndex =
    lesson && lesson.steps.length <= stepIndex && stepIndex > 0
      ? lesson.steps.length - 1
      : stepIndex;
  $: currentStep = lesson && lesson.steps[stepIndex];
  // Anytime the step index changes we broadcast it
  $: if (stepIndex) {
    const event = new Event("nglesson-step-changed");
    (event as any).detail = stepIndex;
    document.dispatchEvent(event);
  }
  document.addEventListener("nglesson-change", (event) => {
    lesson = (event as any).detail;
    restart = {};
  });
  $: if (
    currentStep &&
    currentStep.contentType == ContentTypes.CODE &&
    currentStep.code &&
    preEl
  ) {
    highlight(preEl);
  }
  function moveBack() {
    if (stepIndex > 0) {
      stepIndex -= 1;
      restart = {};
    }
  }
  function moveForward() {
    if (stepIndex <= lesson.steps.length - 2) {
      stepIndex += 1;
      restart = {};
    }
  }

  async function loadedContent(e) {
    const [contentEl] = e.path;

    if (contentEl.tagName === "AUDIO") {
      lessonContainerEl["style"].height = 270 + "px";
      return;
    }
    // wait for the description
    await tick();
    await tick();
    let parentEl = contentEl.parentElement;
    while (parentEl.parentElement !== null) {
      parentEl = parentEl.parentElement;
    }
    const headerHeight = 40;
    console.log(parentEl, "parentEL");
    const controlsEl = parentEl.querySelector("#controls");
    const controlsHeight = controlsEl ? controlsEl.clientHeight : 0;
    const descriptionEl = parentEl.querySelector("#description-only");
    let descriptionHeight = descriptionEl ? descriptionEl.clientHeight : 0;

    const contentHeight =
      contentEl.clientHeight > 400 ? 400 : contentEl.clientHeight;

    // add extra to account for the border padding if there are no steps
    if (controlsHeight === 0 && descriptionHeight > 0) {
      descriptionHeight += 40;
    }

    const stepsEl = parentEl.querySelector("#step");
    (window as any).stepEl = stepsEl;
    const stepHeight = stepsEl ? stepsEl.clientHeight : 0;

    const totalheight =
      headerHeight +
      stepHeight +
      contentHeight +
      descriptionHeight +
      controlsHeight +
      30;

    const height = totalheight > 270 ? totalheight : 270;

    lessonContainerEl["style"].height = height + "px";
  }
  function onClose() {
    const event = new Event("nglesson-close");
    document.dispatchEvent(event);
  }
  function onMin() {
    min = !min;
  }

  function highlight(node: HTMLPreElement) {
    console.log(node, "node");
    node.querySelector("code").innerHTML = currentStep.code;
    (window as any).Prism.highlightAllUnder(
      node,
      (window as any).Prism.languages[currentStep.language]
    );
    setTimeout(() => {
      // adjusting for event match params
      loadedContent({ path: [node] });
    }, 20);
  }

  function youtubeLoaded(contentEl) {
    // This is so the description loads
    setTimeout(() => {
      const headerHeight = 40;
      contentEl.setAttribute("width", "100%");
      // This is the container element
      const parentEl = contentEl.parentElement.parentElement;
      const descriptionEl = parentEl.querySelector("#description-only");
      const descriptionHeight = descriptionEl
        ? // plus 8 is for the padding around the description
          descriptionEl.clientHeight + 8
        : 0;

      // These are the button elements
      const controlsEl = parentEl.querySelector("#controls");

      const controlsHeight = controlsEl ? controlsEl.clientHeight : 0;
      const totalHeight =
        315 + descriptionHeight + controlsHeight + headerHeight;
      contentEl.style.height = `calc(100% - ${
        descriptionHeight + controlsHeight
      }px)`;

      parentEl.style.height = totalHeight + "px";
      parentEl.style.width = 555 + "px";
    }, 50);
  }

  function loadPDF(node) {
    setTimeout(() => {
      const parentEl = node.parentElement.parentElement;
      const descriptionEl = parentEl.querySelector("#description-only");
      const descriptionHeight = descriptionEl ? descriptionEl.clientHeight : 0;

      const controlsEl = parentEl.querySelector("#controls");

      const controlsHeight = controlsEl ? controlsEl.clientHeight : 0;
      const subtractHeight = descriptionHeight + controlsHeight;

      node.style.height = `calc(100% - ${subtractHeight}px)`;

      parentEl.style.height = "500px";

      pdfobject.embed(currentStep.url, node, { forceIframe: true });
    }, 20);
  }
</script>

{#if lesson && currentStep}
  <section
    bind:this={lessonContainerEl}
    class:no-controls={lesson && lesson.steps.length == 1}
    class:min
    style="left: {left}px; top: {top}px;"
    id="nglesson-container"
  >
    <section id="header">
      <div id="left-btn-container">
        <button class="sm" on:click|stopPropagation|preventDefault={onClose}>
          <Fa icon={faTimes} />
        </button>
        <button class="sm" on:click|stopPropagation|preventDefault={onMin}>
          <Fa icon={faWindowMinimize} />
        </button>
      </div>
      <div id="tracker">
        {#if lesson.steps.length > 1}
          <select bind:value={stepIndex}>
            {#each lesson.steps as step, index}
              <option value={index}>{index + 1}</option>
            {/each}
          </select>
          /
          {lesson.steps.length}
        {/if}
      </div>
    </section>
    {#if !min}
      {#if currentStep && currentStep.step && currentStep.contentType !== ContentTypes.YOUTUBE && currentStep.contentType !== ContentTypes.YOUTUBE_PLAYLIST}
        <h3 id="step">{currentStep.step}</h3>
      {/if}
      {#key restart}
        {#if currentStep.contentType === ContentTypes.YOUTUBE_PLAYLIST}
          <section
            id="content"
            class:no-controls={lesson && lesson.steps.length == 1}
            class:description-content={currentStep.description}
          >
            <!-- svelte-ignore a11y-missing-attribute -->
            <iframe
              use:youtubeLoaded
              width="100%"
              src="https://www.youtube.com/embed/videoseries?list={currentStep.youtubeId}?rel=0"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </section>
        {/if}

        {#if currentStep.contentType === ContentTypes.YOUTUBE}
          <section
            id="content"
            class:no-controls={lesson && lesson.steps.length == 1}
            class:description-content={currentStep.description}
          >
            <!-- svelte-ignore a11y-missing-attribute -->
            <iframe
              width="100%"
              use:youtubeLoaded
              src="https://www.youtube.com/embed/{currentStep.youtubeId}?rel=0&start={currentStep.youtubeStartTime ||
                0}"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </section>
        {/if}

        {#if currentStep.contentType === ContentTypes.AUDIO}
          <section
            id="content"
            class:description-content={currentStep.description}
          >
            <!-- svelte-ignore a11y-media-has-caption -->
            <audio on:loadeddata={loadedContent} controls>
              <source src={currentStep.url} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </section>
        {/if}

        {#if currentStep.contentType === ContentTypes.PDF}
          <section
            id="content"
            class:description-content={currentStep.description}
          >
            <div id="pdfView" use:loadPDF />
          </section>
        {/if}

        {#if currentStep.contentType == ContentTypes.CODE}
          <section
            id="content"
            class:description-content={currentStep.description}
          >
            <pre
              bind:this={preEl}
              class:copy={currentStep.canCopy}
              class:not-copy={!currentStep.canCopy}
              use:highlight
              class="language-{currentStep.language} line-numbers">
            <code />
          </pre>
          </section>
        {/if}

        {#if currentStep.contentType === ContentTypes.PICTURE}
          <section
            id="content"
            class:description-content={currentStep.description}
          >
            <!-- This was done to prevent dragging the image -->
            <img
              on:load={loadedContent}
              on:dragstart|preventDefault={(e) => console.log("prevented")}
              src={currentStep.url}
              alt="step {stepIndex + 1}"
              id="main-image"
            />
          </section>
        {/if}

        {#if currentStep.contentType === ContentTypes.VIDEO}
          <section
            id="content"
            class:description-content={currentStep.description}
          >
            <video on:loadeddata={loadedContent} controls>
              <track kind="captions" />
              <source src={currentStep.url} />
            </video>
          </section>
        {/if}
      {/key}

      {#if currentStep.description}
        {#if currentStep.contentType === ContentTypes.MARKDOWN}
          <section id="content">
            <section id="markdown">
              {@html marked(currentStep.description)}
            </section>
          </section>
        {:else}
          <section
            class:no-controls={lesson && lesson.steps.length == 1}
            id="description-only"
          >
            <section id="markdown">
              {@html marked(currentStep.description)}
            </section>
          </section>
        {/if}
      {/if}

      {#if lesson.steps.length > 1}
        <section id="controls">
          <button
            on:click|stopPropagation|preventDefault={moveBack}
            disabled={stepIndex === 0}
            id="back"
          >
            <Fa icon={faArrowLeft} />
          </button>
          <button
            on:click|stopPropagation|preventDefault={moveForward}
            disabled={stepIndex === lesson.steps.length - 1}
            id="forward"
          >
            <Fa icon={faArrowRight} />
          </button>
        </section>
      {/if}
    {/if}
  </section>
{/if}

<style>
  @import url("https://cdnjs.cloudflare.com/ajax/libs/prism/1.22.0/themes/prism.min.css");
  @import url("https://cdnjs.cloudflare.com/ajax/libs/prism/1.22.0/themes/prism-coy.min.css");
  @import url("https://cdnjs.cloudflare.com/ajax/libs/prism/1.22.0/plugins/line-numbers/prism-line-numbers.min.css");
  section#nglesson-container {
    width: 560px;
    height: 560px;
    margin: 0;
    border-radius: 15px;
    position: absolute;
    right: -30px;
    z-index: 200;
    touch-action: none;
    user-select: none;
    font-family: monospace;
    display: flex;
    flex-direction: column;
    /* This makes things *much* easier */
    box-sizing: border-box;
    border: #ac69be 10px solid;
  }
  section#nglesson-container.no-controls {
    border: #ac69be 30px solid;
  }
  section#nglesson-container.min {
    border: none;
  }
  section#header {
    justify-content: space-around;
    flex: 40px 0 0;
    background-color: #505bda;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin: 0;
    position: relative;
  }
  section#header #left-btn-container {
    position: absolute;
    top: 4px;
    left: 8px;
    font-size: 16px;
  }
  section#header #tracker {
    position: absolute;
    top: 2px;
    left: 50%;
    color: white;
    font-size: 25px;
    transform: translateX(-50%);
    vertical-align: top;
  }
  section#header #tracker select {
    height: 35px;
    font-size: 30px;
  }
  section#markdown {
    box-sizing: border-box;
    cursor: default;
    user-select: all;
    font-size: 16px;
    padding: 0 5px;
    background-color: white;
  }
  h3#step {
    text-align: center;
    background-color: #fff;
    padding: 6px;
    margin: 0;
    font-size: 1.5em;
    background-color: #fff;
    user-select: text;
  }

  #content {
    flex: 1;
    background-color: white;
    overflow: hidden;
    background: white;
    padding-bottom: 15px;
    box-sizing: border-box;
  }

  #content.no-controls {
    padding-bottom: 0;
  }

  #content > * {
    width: 100%;
    overflow: hidden;
  }

  audio {
    box-sizing: border-box;
    padding: 0 10px;
    width: calc(100% - 10px);
    margin-top: 20px;
  }

  #description-only {
    background-color: white;
    position: absolute;
    bottom: 50px;
    width: 100%;
    border: 1px solid;
    border-radius: 8px;
    width: calc(100% - 10px);
    margin-left: 5px;
  }

  #description-only.no-controls {
    bottom: 4px;
  }

  img {
    background-color: #fff;
  }

  section#controls {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    height: 50px;
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 5px;
    box-sizing: border-box;
  }
  section#controls button {
    flex: 1;
  }
  .copy {
    user-select: text !important;
    cursor: initial;
  }
  .not-copy {
    user-select: none;
    cursor: default;
  }
  button {
    margin: 5px;
    border: none;
    border-radius: 2px;
    font-size: 20px;
    padding: 5px 10px;
    cursor: pointer;
  }
  #forward {
    margin-right: 0;
  }
  #back {
    margin-left: 0;
  }
  button.sm {
    padding: 0 10px;
  }
  button:focus,
  button:active {
    outline: none;
  }
  button:disabled {
    cursor: not-allowed;
    background-color: rgb(251, 251, 247);
  }
</style>
